import { Children } from 'react';

export const ConditionalComponent = ({ children, statement, fallback }) => {
    return statement ? children : fallback;
};

export const IterationComponent = ({ render, arr }) => Children.toArray(arr?.map((item, index) => render(item, index)));

export const Element = ({ value }) => value;